import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useEffect, useState } from 'react';
import { createFormikComponent, mapFieldToInputProps } from '@vtblife/uikit-formik';
import { Field } from '@vtblife/uikit/dist/legacy';
import { useUserRegion } from '@vtblife/block-kit-utils';
import { RegionSuggest } from './region-suggest';
import { DefaultRegions } from './default-regions';
var SelectRegion = function SelectRegion(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  var _useState = useState(!!value),
    _useState2 = _slicedToArray(_useState, 2),
    isChangedByUser = _useState2[0],
    setIsChangedByUser = _useState2[1];
  var userRegion = useUserRegion();
  useEffect(function () {
    if (!isChangedByUser && userRegion && userRegion.userRegionName && userRegion.userRegionId) {
      onChange({
        label: userRegion.userRegionName,
        value: userRegion.userRegionId
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userRegion]);
  var handleChange = function handleChange(value) {
    setIsChangedByUser(true);
    onChange(value);
  };
  return React.createElement(React.Fragment, null, React.createElement(RegionSuggest, {
    value: value,
    onChange: handleChange
  }), React.createElement(DefaultRegions, {
    onRegionSelect: handleChange
  }));
};
var SelectRegionField = Field(SelectRegion, false, false);
export var FormikSelectRegionField = createFormikComponent(SelectRegionField, mapFieldToInputProps);